import React, { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { FollowButton } from "@logora/parliament.ui.follow_button";
import { AlertModal } from "./AlertModal";
import { useModal } from "@logora/debate.dialog.modal";

export const AlertButton = ({ targetId, targetClass }) => {
	const [alert, setAlert] = useState(false);
	const { showModal } = useModal();
	const dataProvider = useDataProvider();

	useEffect(() => {
		const checkAlert = async () => {
			try {
				const response = await dataProvider.getOne(`alerts/${targetClass}`,
					{ id: targetId },
				);
				setAlert(response.data);
			} catch (error) {
				setAlert(false);
			}
		};

		checkAlert();
	}, [dataProvider, targetId, targetClass]);

	const handleFollow = () => {
		if (alert && Object.keys(alert).length > 0) {
			showModal(<AlertModal record={alert} />);
		} else {
			showModal(<AlertModal targetClass={targetClass} targetId={targetId} onCreateAlert={(alert) => setAlert(alert)}/>);
		}
	}

	return (
		<FollowButton
			key={alert?.id}
			active={alert && Object.keys(alert).length > 0}
			onFollow={handleFollow}
		/>
	);
};
